import styled from 'styled-components';
import { VerticalSeparator as Separator } from '../../../../../components/Commons/Separators/styles';

export const Container = styled.section`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  &#confirm-order-container-pdf {
    width: 1325px;
  }

  .header-container {
    padding: 1.5rem 1.5rem 0;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.grayLight};
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
  }
`;

export const CustomerInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: 0 1.5rem 0;

  & > div {
    display: flex;
    color: ${({ theme }) => theme.colors.grayDark2};
    flex-direction: column;

    &:first-child {
      margin-bottom: 0.75rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 25%;

      &:first-child {
        margin-right: 6rem;
        margin-bottom: unset;
      }
    }
  }

  &.pdf > div {
    width: 45%;

    &:first-child {
      margin-right: 0.75rem;
      margin-bottom: unset;
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  background-color: ${({ theme }) => theme.colors.grayDark3};
  padding: 1rem 1.5rem;

  & > div {
    display: flex;
    flex-direction: column;

    & > span:last-child {
      font-size: 1rem;
      font-weight: bold;
    }
  }
`;

export const VerticalSeparator = styled(Separator)`
  margin: 0 1.5rem;
`;
